import { baseAxios, errorHandler } from "../index";
import Swal from "sweetalert2";
import moment from "moment";

export function createMonthlyReport(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEnterKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .post("monthlyreport/createreport", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      });
    })
    .then(() => {
      window.location.reload();
    })
    .catch(errorHandler);
}

export function getMonthlyReport(dispacth, data) {
  baseAxios
    .get("/monthlyreport/getlaporan", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispacth({ type: "SET_GETREPORT", data: respon.data });
    });
}

export function getGrafikMonthlyReport(dispatch, data) {
  baseAxios
    .get(
      `/monthlyreport/grafikmonthlyreport?dari=${data.dariTgl}&sampai=${data.smpTgl}&idClientWeb=${data.idClientWeb}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      }
    )
    .then(async (respon) => {
      dispatch({ type: "SET_GRAFIKMONTHLYREPORT", data: respon.data });
    })
    .catch(errorHandler);
}
